import { render, staticRenderFns } from "./saleSelect.vue?vue&type=template&id=47483967"
import script from "./saleSelect.vue?vue&type=script&lang=js"
export * from "./saleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports